import React from "react";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export default function ProductCarousel({ products }) {
  const [activeIndex, setActiveIndex] = useState(2);
  const [isInteracting, setIsInteracting] = useState(false);
  const startX = useRef(0);
  const deltaX = useRef(0);

  const isMobile = useSelector((state) => state.screen.isMobile);

  const maxIndex = products.length - 1;

  const next = () => setActiveIndex((i) => Math.min(i + 1, maxIndex));

  const prev = () => setActiveIndex((i) => Math.max(i - 1, 0));

  /* autoplay */
  //   useEffect(() => {
  //     if (isInteracting) return;

  //     const id = setInterval(next, 3500);
  //     return () => clearInterval(id);
  //   }, [isInteracting]);

  /* swipe */
  const onTouchStart = (e) => {
    setIsInteracting(true);
    startX.current = e.touches[0].clientX;
  };

  const onTouchMove = (e) => {
    deltaX.current = e.touches[0].clientX - startX.current;
  };

  const onTouchEnd = () => {
    if (deltaX.current > 60) prev();
    if (deltaX.current < -60) next();

    deltaX.current = 0;
    setTimeout(() => setIsInteracting(false), 800);
  };

  const translationValue = isMobile ? 270 : 336;

  return (
    <div
      className="carousel"
      onMouseEnter={() => setIsInteracting(true)}
      onMouseLeave={() => setIsInteracting(false)}
    >
      <div
        className="carousel-viewport"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div
          className="carousel-track"
          style={{
            transform: `translateX(calc(50% - ${(activeIndex + 0.5) * translationValue}px))`,
          }}
        >
          {products.map((product, index) => (
            <div
              key={index}
              className={`carousel-item ${
                index === activeIndex ? "active" : ""
              }`}
            >
              {React.cloneElement(product, {
                isActive: index === activeIndex,
              })}
            </div>
          ))}
          {/* <div className="container-empty-small" /> */}
        </div>
      </div>

      {/* controls */}
      <div className="carousel-controls">
        <button
          className="carousel-arrow"
          onClick={prev}
          disabled={activeIndex === 0}
        >
          ‹
        </button>

        <button
          className="carousel-arrow"
          onClick={next}
          disabled={activeIndex === maxIndex}
        >
          ›
        </button>
      </div>
    </div>
  );
}
